import { Booking } from 'types';

const DOT_PHYSICAL_AGREEMENT_EMAILED =
    'We’ve sent a copy of the DOT Physical Agreement to your email for your records. You do not need to bring this to your appointment.';
const DOT_PHYSICAL_BRING_FORMS =
    'If applicable, don’t forget to bring the DOT Physical forms or letters you acknowledged previously.';

const isDotPhysicalBooking = ({ reasonForVisit }: Pick<Booking, 'reasonForVisit'>) => reasonForVisit === 'DOT_PHYSICAL';

const getDotPhysicalNextSteps = (booking: Pick<Booking, 'reasonForVisit'>, isAgreementEmailEnabled: boolean) => {
    const isDotPhysical = isDotPhysicalBooking(booking);

    return {
        preVisitForms: isDotPhysical && isAgreementEmailEnabled ? [DOT_PHYSICAL_AGREEMENT_EMAILED] : [],
        visitGuidelines: isDotPhysical ? [DOT_PHYSICAL_BRING_FORMS] : [],
    };
};

export { getDotPhysicalNextSteps, isDotPhysicalBooking };
